import { ButtonProps } from "@mantine/core";
import Button from "@/components/Button";
import classes from "./index.module.css";
import { ButtonHTMLAttributes } from "react";
import { useTranslation } from "@/i18n/client";

type CustomButtonProps = ButtonProps & ButtonHTMLAttributes<HTMLButtonElement> & { "data-testid"?: string };

interface ButtonsGroupProps {
  onLeftButtonClick?: () => void;
  onRightButtonClick?: () => void;
  leftButtonText?: React.ReactNode;
  rightButtonText?: React.ReactNode;
  leftButtonProps?: CustomButtonProps;
  rightButtonProps?: CustomButtonProps;
  withLeftButton?: boolean;
  isLoading?: boolean;
  fullWidth?: boolean;
}

const ButtonsGroup = ({
  onLeftButtonClick,
  onRightButtonClick,
  leftButtonText,
  rightButtonText,
  leftButtonProps,
  rightButtonProps,
  withLeftButton = true,
  fullWidth = false,
  isLoading,
}: ButtonsGroupProps) => {
  const { t } = useTranslation("modals");
  return (
    <div className={rightButtonText && withLeftButton ? classes.buttons : classes.onlyOneButton}>
      {withLeftButton && (
        <Button variant="outline" onClick={onLeftButtonClick} disabled={isLoading} {...leftButtonProps} fullWidth={fullWidth}>
          {leftButtonText ?? t("close")}
        </Button>
      )}
      {rightButtonText && (
        <Button onClick={onRightButtonClick} disabled={isLoading} {...rightButtonProps} fullWidth={fullWidth}>
          {rightButtonText}
        </Button>
      )}
    </div>
  );
};

export default ButtonsGroup;
